import { makeStyles } from "@material-ui/core";

export const useStyle = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    paddingTop: "0px",
  },
  headerMaterial: {
    display: "grid",
    alignItems: "center",
    textAlign: "center",
    height: 50,
    // backgroundColor: "#e0f7fa",
    border: "1px solid",
    borderRadius: 0,
  },
  headerpickup: {
    display: "grid",
    alignItems: "center",
    textAlign: "center",
    height: 50,
    backgroundColor: "#e0f7fa",
    border: "1px solid",
    borderRadius: 0,
  },
  headerpickupWrong: {
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    height: 50,
    backgroundColor: "#e0f7fa",
    border: "1px solid",
    borderRadius: 0,
  },
  headerdelivery: {
    display: "grid",
    alignItems: "center",
    textAlign: "center",
    height: 50,
    backgroundColor: "#e8f5e9",
    border: "1px solid",
    borderRadius: 0,
  },
  header: {
    alignItems: "center",
    textAlign: "center",
    height: 100,
    backgroundColor: theme.palette.background.default,
  },
  text: {
    backgroundColor: "white",
    border: "1px solid",
    alignItems: "center",
    textAlign: "center",
    marginLeft: "10px",
    marginRight: "10px",
  },
  textButton: {
    backgroundColor: "#ffccbc",
    border: "1px solid",
    alignItems: "center",
    textAlign: "center",
    marginLeft: "10px",
    marginRight: "10px",
    color: "#ef5350",
  },
  viewTicket: {
    backgroundColor: "#d4e157",
    border: "1px solid",
    alignItems: "center",
    textAlign: "center",
    marginLeft: "10px",
    marginRight: "10px",
    color: "black",
  },
}));
